module.exports = __webpack_public_path__ + "static/media/calendar.3578d0e3.svg";